import { AsyncAction } from '../../../../../base-classes';
import { IPulseRequestConfiguration, PulseRequestConfiguration } from '../../../../types/PulseInterfaces';

// Related Hurricane Summary dependencies
import { HurricaneOutlookSummaryProvider } from '../../../../providers';

export const GET_HURRICANE_OUTLOOK_SUMMARY = new AsyncAction('GET_HURRICANE_OUTLOOK_SUMMARY');

export function getHurricaneOutlookSummary(
	apiParameters: GetHurricaneOutlookSummaryActionParameters
) {
	const requestConfiguration = new PulseRequestConfiguration(apiParameters);
	return {
		type: GET_HURRICANE_OUTLOOK_SUMMARY.base,
		payload: getActionPayload({  ...apiParameters, ...requestConfiguration })
	};
}

async function getActionPayload(apiParameters: GetHurricaneOutlookSummaryActionParameters) {
	const storeProvider = new HurricaneOutlookSummaryProvider(apiParameters);
	const payload = await storeProvider.getHurricaneOutlookSummary(apiParameters)
	return payload;
}

/**
 * Input Parameters for making an API request to Pulse for getting a hurricane outlook bulletin
 */
export interface GetHurricaneOutlookSummaryActionParameters extends IPulseRequestConfiguration {
	includeForecast2d?: boolean;
	includeForecast7d?: boolean;
}
